(() => {
  const widgets = [...document.querySelectorAll('[data-premium-gift]')];
  if (!widgets.length) return;
  const variant = Number(widgets[0].dataset.variant);
  const root = window.Shopify?.routes?.root || '/';
  let desired = null;
  let running = Promise.resolve();
  let busy = false;
  let timer;
  let lastCart;
  const passes = new WeakSet();
  const isGift = item => Number(item.variant_id) === variant;
  const quantity = cart => cart.items.reduce((sum, item) => sum + (isGift(item) ? 0 : item.quantity), 0);
  async function request(path, body) {
    const response = await fetch(root + path, {
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      ...(body ? {method: 'POST', body: JSON.stringify(body)} : {})
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error('cart');
    return result;
  }
  function paint(cart) {
    const count = quantity(cart);
    const enabled = cart.items.some(isGift);
    widgets.forEach(widget => {
      widget.hidden = count === 0;
      const input = widget.querySelector('[data-premium-gift-toggle]');
      input.checked = desired === null ? enabled : desired;
      input.disabled = busy;
      widget.setAttribute('aria-busy', String(busy));
    });
  }
  function errors(show) {
    widgets.forEach(widget => {
      const error = widget.querySelector('[data-premium-gift-error]');
      error.hidden = !show;
      error.textContent = show ? widget.dataset.error : '';
    });
  }
  async function rebuild(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    const forms = [...document.querySelectorAll('#CartDrawerForm, #CartPageForm')].filter(form =>
      form.id === 'CartPageForm' || form.querySelector('[data-products] .cart__item') ||
      form.closest('.drawer--is-open')
    );
    const ready = () => forms.every(form => {
      const rows = [...form.querySelectorAll('[data-products] .cart__item')];
      return rows.length === cart.items.length && cart.items.every(item => {
        const row = rows.find(node => node.dataset.key === item.key);
        return row && Number(row.querySelector('[name="updates[]"]')?.value) === item.quantity;
      });
    });
    await new Promise((resolve, reject) => {
      const timeout = setTimeout(() => { observer.disconnect(); reject(new Error('render')); }, 7000);
      const observer = new MutationObserver(() => {
        if (ready()) { clearTimeout(timeout); observer.disconnect(); resolve(); }
      });
      forms.forEach(form => observer.observe(form.querySelector('[data-products]'), {childList:true, subtree:true}));
      if (ready()) { clearTimeout(timeout); observer.disconnect(); resolve(); }
    });
  }
  async function reconcile() {
    busy = true;
    if (lastCart) paint(lastCart);
    errors(false);
    try {
      let cart = await request('cart.js');
      const gifts = cart.items.filter(isGift);
      const enabled = desired === null ? gifts.length > 0 : desired;
      const target = enabled ? quantity(cart) : 0;
      const current = gifts.reduce((sum, item) => sum + item.quantity, 0);
      if (current !== target || gifts.length > 1) {
        const updates = {};
        gifts.forEach((item, index) => { updates[item.key] = index === 0 ? target : 0; });
        if (!gifts.length && target) updates[String(variant)] = target;
        cart = await request('cart/update.js', {updates});
        const actual = cart.items.filter(isGift).reduce((sum, item) => sum + item.quantity, 0);
        if (actual !== target) throw new Error('quantity');
        await rebuild(cart);
        if (!cart.items.length && document.querySelector('#CartPageForm')) window.location.reload();
      }
      desired = null;
      lastCart = cart;
      return cart;
    } catch (error) {
      desired = null;
      errors(true);
      throw error;
    } finally {
      busy = false;
      if (lastCart) paint(lastCart);
      else widgets.forEach(widget => {
        widget.hidden = false;
        widget.querySelector('input').disabled = false;
      });
    }
  }
  function queue() {
    running = running.catch(() => {}).then(reconcile);
    return running;
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => { queue().catch(() => {}); }, 120);
  }
  widgets.forEach(widget => {
    widget.querySelector('input').addEventListener('change', event => {
      desired = event.target.checked;
      queue().catch(() => {});
    });
  });
  document.addEventListener('cart:updated', schedule);
  document.querySelectorAll('#CartDrawerForm [data-products], #CartPageForm [data-products]').forEach(container => {
    new MutationObserver(schedule).observe(container, {childList:true});
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('#CartDrawerForm, #CartPageForm')) return;
    if (passes.has(form)) { passes.delete(form); return; }
    const submitter = event.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    clearTimeout(timer);
    queue().then(() => {
      passes.add(form);
      form.requestSubmit(submitter || form.querySelector('[name="checkout"]'));
    }).catch(() => {});
  }, true);
  queue().catch(() => {});
})();
